<router-outlet >
    <p-progressSpinner  *ngIf="this.loader.getLoading()" class="progress-spinner"></p-progressSpinner>
</router-outlet>
